import { Flex, Text } from "@fluentui/react-northstar";
import { ErrorCircleRegular } from "@fluentui/react-icons";
import styled from "styled-components";

const InvalidLink = ({
    title = "Ce lien n'est plus valide",
    description = "La note de frais que vous recherchez n'existe pas ou a déjà été traitée.",
}) => {
    return (
        <Wrapper column hAlign="center" vAlign="center" gap="gap.medium">
            <IconWrapper hAlign="center" vAlign="center">
                <ErrorCircleRegular fontSize={28} />
            </IconWrapper>
            <Flex column hAlign="center" gap="gap.smaller">
                <Title>{title}</Title>
                <Description>{description}</Description>
            </Flex>
        </Wrapper>
    );
};

export default InvalidLink;

const Wrapper = styled(Flex)`
    width: 100%;
    padding: 64px 24px;
`;

const IconWrapper = styled(Flex)`
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background-color: #fdf3f4;
    color: var(--color-danger);
`;

const Title = styled(Text)`
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    color: #242424;
`;

const Description = styled(Text)`
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #616161;
    text-align: center;
    max-width: 360px;
`;
